import { GetTmpTradesApi } from "@/features/accounts/ocr/services/get-tmp-trades-api";
import { GetTmpTradesRequestModel } from "@/features/accounts/ocr/services/get-tmp-trades-model";

/// OCR読み取り結果処理
export class GetTmpTradesService {
  private getTmpTradesApi = new GetTmpTradesApi();
  /**
   * OCR読み取り結果API実行
   */
  public async GetTmpTrades(param: GetTmpTradesRequestModel) {
    return await this.getTmpTradesApi.GetTmpTrades(param);
  }
}
